// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toggleSwitch/ToggleSwitch.scss
// module id = 2962
// module chunks = 0